import React from "react";
import TableViewer from "../TableViewer";
import { v4 as uuidv4 } from 'uuid';
import Graph from "react-graph-vis";
import HttpServices from "../../utils/Http.services";
import BSON from 'bson';
import Loader from "react-loader-spinner";
var ObjectID = require("bson-objectid");

class NetworkMapWidget extends React.Component {

    state = {
        show: false,
        graph: {

        }
    }


    graph = {
        nodes: [
            // { id: '*', label: "Platform", title: "Platform", size: 40, color: '#fff', font: { color: "#345", weight: 'bold' }, shape: "circularImage", image: '/images/logo-t.png' },
            // { id: 2, label: "Node 2", title: "node 2 tootip text",group:0,shape:'circle',color:'#abc' },
            // { id: 3, label: "Node 3", title: "node 3 tootip text",shape:'circle',color:'#abc' },
            // { id: 4, label: "Node 4", title: "node 4 tootip text",shape:'circle',color:'#abc' },
            // { id: 5, label: "Node 5", title: "node 5 tootip text",shape:'circle',color:'#abc' }
        ],
        edges: [
            // { from: "*", to: 2, label:'Test' },
            // { from: "*", to: 3 },
            // { from: 2, to: 4 },
            // { from: 2, to: 5 }
        ]
    };

    options = {
        layout: {
            // hierarchical: true
        },
        edges: {
            color: "#789"
        },
        height: "400px"
    };

    events = {
        select: function (event) {
            var { nodes, edges } = event;
        }
    };



    componentDidMount() {
        this.init()
        window.addEventListener('resize', this.sizeChange)
    }

    componentDidUpdate(prevProps) {
        if ((JSON.stringify(prevProps.data?.gateways) != JSON.stringify(this.props.data?.gateways))) {

            this.init()
        }
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.sizeChange)

    }

    sizeChange = () => {
        this.setState({ show: false }, () => {
            this.setState({ show: true })
        })
    }

    init() {
        this.setState({ show: false }, () => {
            this.setState({ thing: {}, data: {} }, () => {
                let gatewaysList = this.props.data.gateways

                let filter = {}
                if (Array.isArray(gatewaysList) && gatewaysList.length > 0) {

                    let listOfIds = []

                    // gatewaysList.forEach(element => {
                    //     if (ObjectID.isValid(element)) {
                    //         // listOfIds.push({ $toObjectId: element })
                    //         listOfIds.push( BSON.ObjectId(element))

                    //     }
                    // });

                    filter = { $or: [{ _id: { $in: gatewaysList } }, { gateway: { $in: gatewaysList } }] }
                    // filter= {type:'Gateway'}
                }
                // console.log(filter)

                HttpServices.request("getMyThings", { filter, convertNetwordId: true }, (fetchResult, fetchError, status) => {

                    if (fetchError) { return }

                    if (fetchResult && fetchResult.info) {
                        let nodes = [
                            { id: '*', label: "Platform", title: "Platform", size: 54, color: { background: '#778899ee', border: '#789' }, borderWidth: 3, font: { color: "#345", weight: 'bold' }, shape: "circularImage", image: '/images/logo-w.png' },
                        ]
                        let edges = []

                        fetchResult.info.forEach(thing => {
                            // let node = { id: thing._id }
                            let node = {}
                            if (thing.type == 'Gateway') {
                                // node ={ id: 2, label: "Node 2", title: "node 2 tootip text",group:0,shape:'circle',color:'#abc' }
                                node = { color: { background: 'rgba(255, 99, 132,0.9)', border: 'rgba(255, 99, 132,1)' }, borderWidth: 2, size: 35, font: { color: "#000" }, shape: "dot", label: thing.name }
                                edges.push({ to: "*", from: thing._id })
                                node.id = thing._id
                                nodes.push(node)

                            } else {

                                node = { color: { background: 'rgba(254, 192, 47,0.9)', border: 'rgb(254, 192, 47)' }, size: 20, font: { color: "#000" }, shape: "dot", label: thing.name }
                                let mgateway = null
                                fetchResult.info.forEach(gateway => {
                                    // console.log(thing.gateway)
                                    // console.log(gateway._id)
                                    if (gateway._id == thing.gateway) {
                                        mgateway = gateway._id
                                        // console.log("FOUND")
                                        // console.log(gateway)
                                    }
                                });

                                edges.push({ to: mgateway ?? "*", from: thing._id })
                                node.id = thing._id
                                nodes.push(node)

                            }


                        });
                        // console.log(nodes)
                        // console.log(fetchResult)
                        let graph = { nodes, edges }
                        this.setState({ graph }, () => {
                            this.setState({ show: true })
                        })
                    }
                })


            })
        })
    }


    render() {
        return (
            <div className="w-100  px-2 flexcc" style={{ height: '400px', }} >
                {this.state.show ? (
                    <Graph
                        graph={this.state.graph}
                        options={this.options}
                        events={this.events}
                        getNetwork={network => {
                            //  if you want access to vis.js network api you can set the state in a parent component using this property
                        }}
                    />
                ) : (
                    <div className="flexcc h-100 w-100">
                        <Loader
                            type={"Oval"}
                            color={"#202020"}
                            height={50}
                            width={50}
                        />
                    </div>
                )}
            </div >
        )
    }
}



export default NetworkMapWidget;
